import React from 'react';

const PressureYokogawaApp = () => {
  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <iframe
        src="/projectList/pressure-app.html"
        title="Pressure Yokogawa App"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
     
    </div>
    
  );
}

export default PressureYokogawaApp;